module.exports = __webpack_public_path__ + "img/20200515-4.d289a943.jpg";